import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { containerClasses } from '@mui/system';
import { withRouter } from 'react-router-dom';
import BottomBox from './BottomBox';
import Pop from './Pop';
import Helmet from 'react-helmet';
import './blog.css';
import { Box } from '@mui/material';



const Blog = (props) => {
  const { history } = props;
  return (
    <div className="main-body">
    <Helmet bodyAttributes={{style: 'background-color : #f7f7f7'}}/> 
    <Pop btcolor='black'/>
    
    <Box 
             sx = {theme => ({ [theme.breakpoints.up('sm')]:{backgroundColor:'#202020',width:'100%',height:'50vh',maxHeight:'50%'},
             [theme.breakpoints.between('0','600')]:{backgroundColor:'#202020',width:'100%',height:'35vh',maxHeight:'50%'}
             })}
        
        />
    
    <p onClick={()=> history.push('/')} className='blog__head'>
      Untouched
    </p>
   
    <div className='blog__heading'>
      <p>Blogs</p> 
      </div>
    <div className="mid-container">



    {/* <div className="sidetxt">
      <p>Untouched</p>
    </div>   */}
    <div className="card-container">
    {/* <Card 
          sx = {theme => ({ [theme.breakpoints.up('sm')]:{marginRight:'2%',width:'30vw',height:'auto'},
          [theme.breakpoints.between('0','600')]:{width:'90vw',height:'auto'}
          })}
    >
      <div className='container-image-1'>
            <img id="card-image-1" src="/images/blog/hand.png" alt="" />
      </div>
      <CardContent>
        <Typography sx={{'&:hover': { color: '#7D8B71'},cursor:'pointer'}} onClick={()=> history.push('/blog/aerospace')} style={{fontSize:'1.1rem',fontWeight:600}} gutterBottom variant="h5" component="div">
         The aerospace startup is working to build an autonomous sanitizer machine
        </Typography>
        <Typography style={{fontSize:'0.7rem',opacity:0.8}}>
          <p>BY Shariq | 17 FEB 2022</p>
        </Typography>
        <hr  className='blog__hr' />
        <Typography  className='card__info' style={{fontSize:'0.875rem'}} variant="h4" color="text.secondary">
         My team, some users and investors asked me why is an aerospace startup working to...
        </Typography>
      </CardContent>
    </Card> */}
    
    <Card 
          sx = {theme => ({ [theme.breakpoints.up('sm')]:{marginRight:'2%',width:'30vw',height:'auto'},
          [theme.breakpoints.between('0','600')]:{marginTop:'5%', marginBottom:'10%',width:'90vw',height:'auto'}
          })}
    
    >

    <div className='container-image-2' >
        <img id="card-image-2"  src="/images/blog/rupee.png" alt="" />
    </div>

      <CardContent>
        <Typography sx={{'&:hover': { color: '#7D8B71'}, cursor:'pointer'}} onClick={()=> history.push('/blog/invest-project')} style={{fontSize:'1.1rem',fontWeight:600}} gutterBottom variant="h5" component="div">
            Five Reasons to invest in the project Untouched
        </Typography>
        <Typography style={{fontSize:'0.7rem',opacity:0.8}}>
          <p>BY Shariq | 17 FEB 2022</p>
        </Typography>
        <hr className='blog__hr' />
        <Typography className='card__info' style={{fontSize:'0.875rem'}}variant="h4" color="text.secondary">
        5 Reasons to invest in the project Generating wealth & employability Low Risk....
        </Typography>
      </CardContent>
      
    </Card>
    </div>
    </div>
      <BottomBox/> 
    </div>
  );
}

export default withRouter(Blog);

 
